import { errorAction, successfulAction } from '@shared/actions';
import getCartId from '@core/reducers/cart/selectors/getCartId';

const updateCartProp = ({
  updateProp,
  actionType,
  errorMessage,
  mute = false,
}) => async (dispatch, getState) => {
  const type = actionType;
  try {
    dispatch({ type: actionType });

    const cartId = getCartId(getState());

    const { success, data, error } = await updateProp(cartId);

    if (success) {
      dispatch(successfulAction({ type, payload: { cart: data } }));
    } else {
      dispatch(errorAction({ type, error, errorMessage, mute }));
    }
    return success;
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage, mute }));
    return false;
  }
};

export default updateCartProp;
